<template>
  <popup :opened="isDisplayed" @close="$emit('close')">
    <div class="sticky top-0 z-10">
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="absolute text-center bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600 pt-4 pb-3 mt-13 w-8/12 left-2/12 right-2/12"
          v-if="messageHeader == 'saveIsSuccess'"
        >
          <icon name="checkmark-circle-2" class="inline-block mr-2" />
          {{ messageSaveSuccess }}
        </div>
        <div
          class="absolute text-center bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600 pt-4 pb-3 mt-13 w-6/12 left-3/12 right-3/12"
          v-if="messageHeader == 'error'"
        >
          <icon name="checkmark-circle-2" class="inline-block mr-2" />
          {{ messageSaveError }}
        </div>
      </transition>

      <!-- Save button -->
      <save-button
        :saving="saving"
        @save="$emit('saveRights')"
        class="right-15 top-15"
      />
    </div>

    <!-- BEGIN Content modal beneficiary rights -->
    <div class="w-full my-5 lg:my-15 2xl:my-20">
      <h3 class="mb-10">Gérer les droits d'accès</h3>
      <div
        class="w-full text-left text-pink-600 text-lg mb-10 mx-5 lg:mx-15 2xl:mx-20"
      >
        DROITS ET RESTRICTIONS
      </div>

      <div class="flex justify-start mx-5 lg:mx-15 2xl:mx-20">
        <div class="flex-none">
          <div
            v-if="
              listModulesPages.filter(
                (m) =>
                  permissions.includes(m.name + '_read') &&
                  m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
              ).length > 0
            "
          >
            <checkbox-indigo
              name="Lecture"
              libelle="LECTURE"
              color-libelle="text-indigo-600"
              size-libelle="text-base"
              :value="(neopassFormRights.read || {}).all"
              @input="
                (newValue) => {
                  $emit('check', {
                    type: 'read',
                    module: 'all',
                    page: null,
                    newValue: newValue,
                    checkall: true,
                    decheckall: false,
                  });
                }
              "
            />
          </div>
          <div
            v-for="(mod, numMod) in listModulesPages.filter(
              (m) =>
                permissions.includes(m.name + '_read') &&
                m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
            )"
            :key="numMod"
            class="m-3"
          >
            <div>
              <checkbox-indigo
                :name="mod.name"
                :libelle="mod.display_name"
                :value="((neopassFormRights.read || {})[mod.name] || {}).all"
                size-libelle="text-base"
                @input="
                  (newValue) => {
                    $emit('check', {
                      type: 'read',
                      module: mod.name,
                      page: 'all',
                      newValue: newValue,
                      checkall: true,
                      decheckall: true,
                    });
                  }
                "
                class="mb-1.5"
              />
            </div>

            <div
              v-for="(page, numPage) in mod.pages.filter((p) =>
                permissions.includes(p.name + '_read')
              )"
              :key="numPage"
            >
              <checkbox-indigo
                :name="page.name"
                :libelle="page.display_name"
                color-libelle="text-gray-600"
                size-libelle="text-base"
                weight-libelle="font-light"
                :value="
                  ((neopassFormRights.read || {})[mod.name] || {})[page.name]
                "
                @input="
                  (newValue) => {
                    $emit('check', {
                      type: 'read',
                      module: mod.name,
                      page: page.name,
                      newValue: newValue,
                      checkall: false,
                      decheckall: true,
                    });
                  }
                "
              />
            </div>
          </div>
        </div>
        <div class="flex-grow" />
        <div class="flex-none">
          <div
            v-if="
              listModulesPages.filter(
                (m) =>
                  permissions.includes(m.name + '_edit') &&
                  m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
              ).length > 0
            "
          >
            <checkbox-indigo
              name="Ecriture"
              libelle="ECRITURE"
              color-libelle="text-indigo-600"
              size-libelle="text-base"
              :value="(neopassFormRights.edit || {}).all"
              @input="
                (newValue) => {
                  $emit('check', {
                    type: 'edit',
                    module: 'all',
                    page: null,
                    newValue: newValue,
                    checkall: true,
                    decheckall: false,
                  });
                }
              "
              class="w-1/2"
            />
          </div>

          <div
            v-for="(mod, numMod) in listModulesPages.filter(
              (m) =>
                permissions.includes(m.name + '_edit') &&
                m.name != constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
            )"
            :key="numMod"
            class="m-3"
          >
            <div>
              <checkbox-indigo
                :name="mod.name"
                :libelle="mod.display_name"
                :value="((neopassFormRights.edit || {})[mod.name] || {}).all"
                size-libelle="text-base"
                @input="
                  (newValue) => {
                    $emit('check', {
                      type: 'edit',
                      module: mod.name,
                      page: 'all',
                      newValue: newValue,
                      checkall: true,
                      decheckall: true,
                    });
                  }
                "
                class="mb-1.5"
              />
            </div>
            <div
              v-for="(page, numPage) in mod.pages.filter((p) =>
                permissions.includes(p.name + '_edit')
              )"
              :key="numPage"
            >
              <checkbox-indigo
                :name="page.name"
                :libelle="page.display_name"
                color-libelle="text-gray-600"
                size-libelle="text-base"
                weight-libelle="font-light"
                :value="
                  ((neopassFormRights.edit || {})[mod.name] || {})[page.name]
                "
                @input="
                  (newValue) => {
                    $emit('check', {
                      type: 'edit',
                      module: mod.name,
                      page: page.name,
                      newValue: newValue,
                      checkall: false,
                      decheckall: false,
                    });
                  }
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Content modal beneficiary rights -->
  </popup>
</template>

<script>
import Popup from './../Popup.vue';
import SaveButton from '../SaveButton.vue';
import Constants from './../../constants';
import CheckboxIndigo from '../Inputs/CheckboxIndigo.vue';

export default {
  components: {
    Popup,
    SaveButton,
    CheckboxIndigo,
  },

  props: {
    isDisplayed: {
      type: Boolean,
      required: true,
    },
    messageHeader: {
      type: String,
      required: true,
    },
    messageSaveSuccess: {
      type: String,
      required: false,
      default: 'Les droits ont bien été enregistrés.',
    },
    messageSaveError: {
      type: String,
      required: false,
      default: "Erreur d'enregistrement des données.",
    },
    saving: {
      type: Boolean,
      required: false,
      default: false,
    },
    listModulesPages: {
      type: Array,
      required: true,
    },

    permissions: {
      type: Array,
      required: true,
    },

    neopassFormRights: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      constants: Constants,
    };
  },
};
</script>
